import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore, Store } from './store';
import Wrap from './Wrap';
import Live from './Live';
import Nav from './Nav';
import Main from './Main';
import Bottom from './Bottom';

dayjs.extend(isSameOrAfter);

const Layout = ({ content }) => {
    const { params, live } = content;
    const { id } = params;

    const [liveInfo, setLiveInfo] = useState(null);

    useEffect(
        () => {
            if (live) {
                const { startTime, endTime, liveUrl, showLive } = live;

                if (showLive && liveUrl && startTime && endTime) {
                    const startTimeObj = dayjs(startTime);
                    const endTimeObj = dayjs(endTime);

                    if (startTimeObj.isValid() && endTimeObj.isValid()) {
                        const nowTimeObj = dayjs();

                        if (nowTimeObj.isSameOrAfter(startTimeObj) && nowTimeObj.isBefore(endTimeObj)) {
                            setLiveInfo(live);
                        }
                    }
                }
            }
        },
        [live],
    );

    const [noticeText, setNoticeText] = useState(null);

    useEffect(
        () => {
            if (live) {
                const { startTime, endTime, liveUrl, showLive, notice } = live;

                if (showLive && liveUrl && startTime && endTime) {
                    const startTimeObj = dayjs(startTime);
                    const endTimeObj = dayjs(endTime);

                    if (startTimeObj.isValid() && endTimeObj.isValid()) {
                        const nowTimeObj = dayjs();

                        if (nowTimeObj.isBefore(startTimeObj)) {
                            setNoticeText(notice);
                        }
                    }
                }
            }
        },
        [live],
    );

    return (
        <ListStore.Provider>
            <Store.Provider>
                <Wrap>
                    {liveInfo ? <Live content={{ liveInfo }} /> : null}
                    <Nav />
                    <Main content={{ id, noticeText }} />
                    <Bottom />
                </Wrap>
            </Store.Provider>
        </ListStore.Provider>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
